var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "desktop-feature-original-gradient",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF500B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#desktop-feature-original-gradient)",
    d: "m5.635 12.7068 1.829 1.829 1.414-1.415-1.829-1.828 1.415-1.414 1.828 1.828 1.414-1.414-1.827-1.829 1.414-1.414 1.828 1.829 1.415-1.415-1.829-1.828 2.829-2.828c.39-.3904 1.023-.3904 1.413 0l4.242 4.242c.3904.3905.3904 1.0235 0 1.414L8.464 21.1918c-.3906.3911-1.0244.3911-1.415 0l-4.242-4.242c-.3904-.3905-.3904-1.0235 0-1.414L5.635 12.7068Zm8.485 5.657 4.243-4.243 2.636 2.636v4.243h-4.242l-2.637-2.636Zm-8.485-8.486L2.807 7.0498c-.3911-.3906-.3911-1.0244 0-1.415l2.828-2.828c.3905-.3904 1.0235-.3904 1.414 0l2.83 2.828-4.244 4.243Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginal);
export default __webpack_public_path__ + "static/media/original.132a1974160c615c234ba5754ce8cd6c.svg";
export { ForwardRef as ReactComponent };